import React from "react"
import styled from "styled-components/macro"
import colors from "../../scripts/colors"
import TitleArrow from "../../images/iconmonstr-arrow-24---outline.svg"
import "@fontsource/noto-sans-jp/300.css"

type PropTypes = {
  title: string
  id?: string
}

const MoreInfoSection = styled.div`
  display: flex;
  justify-content: center;
`

const MoreInfoStyles = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
`

const MoreInfoHeader = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border: 2px solid ${colors("grey", "xlt")};
  border-bottom: none;
  padding: 20px;
  padding-bottom: 0;
  position: relative;
  z-index: 1000;
  h2 {
    margin: 0 0 13px;
    line-height: 1em;
    font-size: 25px;
    font-weight: 300;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: ${colors("blue")};
  }
  svg {
    color: ${colors("purple")};
    width: 25px;
    margin-bottom: -10px;
  }
`

const MoreInfoContent = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: column;
  background-color: white;
  border: 2px solid ${colors("grey", "xlt")};
  padding: 25px;
  @media screen and (min-width: 790px) {
    flex-direction: row;
    flex-wrap: nowrap;
  }
`

const MoreInfo: React.FC<PropTypes> = ({ title, id, children }) => {
  return (
    <MoreInfoSection id={id} className="MoreInfo-Section MoreInfo">
      <MoreInfoStyles className="MoreInfo-styles">
        <MoreInfoHeader className="MoreInfo-header">
          <h2>{title}</h2>
          <TitleArrow />
        </MoreInfoHeader>
        <MoreInfoContent className="MoreInfo-content">
          {children}
        </MoreInfoContent>
      </MoreInfoStyles>
    </MoreInfoSection>
  )
}

export default MoreInfo
